import styled from '@emotion/styled';
import { EnhancedOddsIcon, FlashOddsIcon, SuperOddsIcon, YourOddsBubbleIcon, } from '@ui-kit-ngs/icons';
import React from 'react';
import { concessionIconPartialCSS } from './StyledSelectionButton';
const SelectionEnhancedOddsIcon = styled(EnhancedOddsIcon) `
  ${concessionIconPartialCSS}
`;
const SelectionFlashOddsIcon = styled(FlashOddsIcon) `
  ${concessionIconPartialCSS}
`;
const SelectionDoubleYourOddsIcon = styled(YourOddsBubbleIcon) `
  ${concessionIconPartialCSS}
`;
const SelectionSuperOddsIcon = styled(SuperOddsIcon) `
  ${concessionIconPartialCSS}
`;
const SelectionButtonIcons = ({ isEnhanced, isSuperOdds, isFlashOdds, isDoubleYourOdds, customIcon, }) => (React.createElement(React.Fragment, null,
    isEnhanced && (React.createElement(SelectionEnhancedOddsIcon, { width: 12, "data-testid": "enhanced-odds-icon" })),
    isFlashOdds && (React.createElement(SelectionFlashOddsIcon, { width: 12, "data-testid": "flash-odds-icon" })),
    isSuperOdds && (React.createElement(SelectionSuperOddsIcon, { width: 12, "data-testid": "super-odds-icon" })),
    isDoubleYourOdds && (React.createElement(SelectionDoubleYourOddsIcon, { width: 12, "data-testid": "double-odds-icon" })),
    customIcon && customIcon));
export default SelectionButtonIcons;
